import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SidebarComponent} from './sidebar/sidebar.component';
import {HeaderComponent} from './header/header.component';
import {LayoutComponent} from './layout.component';
import {RouterModule} from '@angular/router';
import {MatCardModule} from '@angular/material/card';
import {MatIconModule} from '@angular/material/icon';
import {MatListModule} from '@angular/material/list';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatToolbarModule} from '@angular/material/toolbar';
import {AlertModule} from '@components/alert/alert.module';
import {MatFormFieldModule} from '@angular/material/form-field';
import {JoyrideModule} from 'ngx-joyride';

@NgModule({
    declarations: [SidebarComponent, HeaderComponent, LayoutComponent],
    imports: [
        CommonModule,
        AlertModule,
        RouterModule,
        MatCardModule,
        MatSidenavModule,
        MatToolbarModule,
        MatIconModule,
        MatListModule,
        MatFormFieldModule,
        JoyrideModule,
    ]
})
export class LayoutModule {
}
